import React from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import { Paper, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import {
  Receipt,
  ReceiptStatus,
} from "../../../../../../domain/models/receipt-model";
import { useNavigate } from "react-router-dom";

type Props = {
  receipt: Receipt;
  onStart: (id: number) => void;
  onSeeReport?: (id: number) => void;
};

export const ReceiptCard: React.FC<Props> = ({
  receipt,
  onStart,
  onSeeReport,
}) => {
  const navigate = useNavigate();
  const getStatus = (): "Não Iniciada" | "Com Pendências" | "Finalizada" => {
    if (receipt.status === ReceiptStatus.notChecked) return "Não Iniciada";
    if (receipt.status === ReceiptStatus.checked) return "Finalizada";
    return "Com Pendências";
  };

  const getButtonText = (): "Iniciar" | "Ver" | "Refazer" => {
    if (receipt.status === ReceiptStatus.notChecked) return "Iniciar";
    if (receipt.status === ReceiptStatus.checked) return "Ver";
    return "Refazer";
  };

  const getColor = (): "error" | "warning" | "success" => {
    if (receipt.status === ReceiptStatus.notChecked) return "error";
    if (receipt.status === ReceiptStatus.checked) return "success";
    return "warning";
  };
  return (
    <Paper sx={{ height: "120px" }}>
      <Stack direction="row">
        <Box
          sx={{
            width: "60%",
            height: "120px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography fontWeight="bold">{receipt.name}</Typography>
        </Box>
        <Box
          sx={{
            width: "40%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-around",
          }}
        >
          <Chip
            label={getStatus()}
            variant="outlined"
            color={getColor()}
            size="small"
          />
          <Stack direction={"column"} spacing={1}>
            {!(
              receipt.status === ReceiptStatus.checked ||
              receipt.status === ReceiptStatus.notChecked
            ) && (
              <Button
                variant="contained"
                size="small"
                color="primary"
                sx={{ color: "white" }}
                onClick={onSeeReport?.bind(null, receipt.id!)}
              >
                Ver
              </Button>
            )}
            <Button
              variant="contained"
              color="secondary"
              size="small"
              sx={{ color: "white" }}
              onClick={onStart.bind(null, receipt.id!)}
            >
              {getButtonText()}
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
};
